export default __webpack_public_path__ + "static/media/dashboard_careplan_tick_icon.5864bd0b.svg";